export default __webpack_public_path__ + "static/media/logo.6a82f811.svg";